import storeConnection from './container';
import Main from './Main';

export default storeConnection(Main);
